import { useDataProvider, useGetOne, useNotify, useTranslate } from 'react-admin';
import { CustomButton } from '@/components/global/buttons/CustomButton.jsx';
import { IconButton, Tooltip } from '@mui/material';
import DownloadFileIcon from '@/assets/icons/download-file-icon.svg?react';
import RefreshIcon from '@/assets/icons/refresh-icon.svg?react';
import { useState } from 'react';
import PropTypes from 'prop-types';

const DeviceLogsHeader = ({ deviceId, logsRequested }) => {
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const { data: logsData } = useGetOne('device', { id: deviceId }, { enabled: !!deviceId });
    const [refreshRequested, setRefreshRequested] = useState(false);
    const translate = useTranslate();

    const handleLogsRefresh = () => {
        dataProvider
            .post(`device/${logsData.id}/request-logs`)
            .then(() => {
                notify(translate('resources.device.fields.logsRequestSent'), { type: 'success' });
                setRefreshRequested(true);
            })
            .catch(error => notify(`${translate('common.errorOccurred')}: ${error.message}`, { type: 'error' }));
    };

    return (
        <>
            <CustomButton
                color='primary'
                label={logsData?.recentLogs ? translate('resources.device.labels.downloadFullLogs') : translate('resources.device.labels.downloadingLogs')}
                endIcon={<DownloadFileIcon />}
                onClick={e => {
                    e.stopPropagation();
                    dataProvider.downloadFile(`/device-log-file/${logsData.id}`, logsData.serialNumber);
                }}
                disabled={!logsData?.recentLogs}
                sx={{
                    display: logsData?.recentLogs || logsRequested ? 'flex' : 'none',
                    margin: '0 8px 0 auto',
                    height: '44px',
                    '& .MuiButton-endIcon': {
                        '& svg': {
                            color: 'inherit',
                        },
                    },
                }}
            />
            <Tooltip title={translate('resources.device.labels.resendLogsRequest')} arrow classes={{ tooltip: 'tooltip-black' }}>
                <IconButton
                    type='button'
                    className='refresh-icon'
                    onClick={e => {
                        e.stopPropagation();
                        handleLogsRefresh();
                    }}
                    disabled={logsData?.sendLogs || refreshRequested || logsRequested}
                    sx={{
                        display: logsData?.recentLogs || logsRequested ? 'flex' : 'none',
                    }}
                >
                    <RefreshIcon />
                </IconButton>
            </Tooltip>
        </>
    );
};

DeviceLogsHeader.propTypes = {
    deviceId: PropTypes.string,
    logsRequested: PropTypes.bool.isRequired,
};

export default DeviceLogsHeader;
